import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.scss';


const MapContainer = (props) => {
  const {
    animateChargerHover, animatePlaceHover, className, children, scrollwheel, ...extraProps
  } = props;
  return (
    <div
      className={classNames('map-container', {
        'animate-charger-hover': animateChargerHover,
        'animate-place-hover': animatePlaceHover,
        scrollwheel,
        'no-scrollwheel': !scrollwheel,
      }, className)}
      styleName='map-container'
      {...extraProps}
    >

      { children }

    </div>
  );
};

MapContainer.propTypes = {
  animateChargerHover: PropTypes.bool,
  animatePlaceHover: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  id: PropTypes.string,
  scrollwheel: PropTypes.bool,
};

MapContainer.defaultProps = {
  animateChargerHover: false,
  animatePlaceHover: false,
  className: null,
  children: null,
  id: 'map-container',
  scrollwheel: true,
};

export default MapContainer;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/MapContainer/index.jsx